export default {"src":"/_next/static/media/TXT.d1980611.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};